<template>
    <div class="relative z-10" aria-labelledby="modal-title" role="dialog" aria-modal="true">
  <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"></div>
  <div class="fixed inset-0 z-10 w-screen overflow-y-auto">
    <div class="flex h-4/5 items-end justify-center p-4 text-center sm:items-center sm:p-0">
      <div class="relative transform overflow-hidden  bg-white text-left shadow-xl transition-all sm:my-8 w-full sm:max-w-lg">
        <div class="bg-gray-800 text-white p-3">
          <div>
            <div>1.ปริ้นโปสเตอร์</div>
            <div>2.ส่งหลักฐานที่ติดโปสเตอร์หน้าร้าน</div>
            <div>3.เขี่ยนวันที่</div>
            <div>4.ส่งที่เฟสบุ้ค Workerkey เพื่อต่อเวลาอายุ</div>
          </div>
          <div >
          <button @click="cancelModal" type="button" class="mt-1.5 w-full justify-center rounded bg-gray-300 px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm   hover:bg-white  duration-300">ยกเลิก</button>
        </div>
        </div>
      </div>
    </div>
  </div>
  </div>
  
  </template>
  <script>
  import { ref } from 'vue'
import getUser from '@/composables/getUser'
import { projectFirestore } from '@/firebase/config'
  export default {
    setup(props,context) {
      const { user } = getUser()
      const cancelModal = e =>{context.emit('cancelModal')}

      const partner = ref()
      projectFirestore.collection('partners').doc(user.value.uid).get().then(partnerDoc =>{
        partner.value = partnerDoc.data()
      })
        

      return { cancelModal,partner }
    },
  }
  </script>